// extracted by css-extract-rspack-plugin
export default {"row":"row-XqYcRP","rowLabel":"rowLabel-zEQJAF","rowValue":"rowValue-EQLgP_","rowValueIsNumber":"rowValueIsNumber-APO4ph","rowValueCappedMaxLength":"rowValueCappedMaxLength-Q3OHqf"};